<form #form="ngForm">
    <!--Carte Délais forfaitaires-->
    <mat-card>
        <ng-container *ngIf="!isLoadingReglesConf; else loadingReglesConf">
            <mat-card-title>
                <span class="r-flex align-items-center">
                    <span [translate]="'admin.frais.indemnites.parametres.delaisForfaitaires.title'"></span>
                    <mat-icon class="material-icons-outlined ms-1" [matTooltip]="'admin.frais.indemnites.parametres.delaisForfaitaires.tooltip' | translate">info</mat-icon>
                </span>
            </mat-card-title>
            <mat-card-content>
                <!--Ligne Départs-->
                <div class="row">
                    <!--Délai départ train-->
                    <custom-input
                            ngDefaultControl
                            customType="number"
                            [(ngModel)]="model.reglesConf.delaiDepartTrain"
                            name="delaiDepartTrain"
                            [min]="0"
                            libelle="admin.frais.indemnites.parametres.delaisForfaitaires.delaiDepartTrain"
                            [suffix]="'admin.frais.indemnites.parametres.delaisForfaitaires.uniteDepartTrain' | translate">
                    </custom-input>

                    <!--Délai départ avion-->
                    <custom-input
                            ngDefaultControl
                            customType="number"
                            [(ngModel)]="model.reglesConf.delaiDepartAvion"
                            name="delaiDepartAvion"
                            [min]="0"
                            libelle="admin.frais.indemnites.parametres.delaisForfaitaires.delaiDepartAvion"
                            [suffix]="'admin.frais.indemnites.parametres.delaisForfaitaires.uniteDepartAvion' | translate">
                    </custom-input>
                </div>

                <!--Ligne Retours-->
                <div class="row">
                    <!--Délai retour train-->
                    <custom-input
                            ngDefaultControl
                            customType="number"
                            [(ngModel)]="model.reglesConf.delaiRetourTrain"
                            name="delaiRetourTrain"
                            [min]="0"
                            libelle="admin.frais.indemnites.parametres.delaisForfaitaires.delaiRetourTrain"
                            [suffix]="'admin.frais.indemnites.parametres.delaisForfaitaires.uniteRetourTrain' | translate">
                    </custom-input>

                    <!--Délai retour avion-->
                    <custom-input
                            ngDefaultControl
                            customType="number"
                            [(ngModel)]="model.reglesConf.delaiRetourAvion"
                            name="delaiRetourAvion"
                            [min]="0"
                            libelle="admin.frais.indemnites.parametres.delaisForfaitaires.delaiRetourAvion"
                            [suffix]="'admin.frais.indemnites.parametres.delaisForfaitaires.uniteRetourAvion' | translate">
                    </custom-input>
                </div>
            </mat-card-content>
        </ng-container>
    </mat-card>

    <!--Carte Pourcentages-->
    <mat-card>
        <ng-container *ngIf="!isLoadingPourcentages; else loadingPourcentages">
            <mat-card-title>
                <span class="r-flex align-items-center">
                    <span [translate]="'admin.frais.indemnites.parametres.pourcentages.title'"></span>
                    <mat-icon class="material-icons-outlined ms-1" [matTooltip]="'admin.frais.indemnites.parametres.pourcentages.tooltip' | translate">info</mat-icon>
                </span>
            </mat-card-title>
            <mat-card-content>
                <!--Affichage des pourcentages par ligne de deux colonnes-->
                <div class="row" *ngFor="let ligne of listePourcentagesParLigne; index as idxLigne; trackBy: trackByIndex">
                    <ng-container *ngFor="let item of ligne; index as idxItem; trackBy: trackByDomaine">
                        <custom-input
                                ngDefaultControl
                                customType="number"
                                [(ngModel)]="item.pourcentage"
                                [name]="'pourcentage-' + ((idxLigne * 2) + idxItem)"
                                [min]="0"
                                [nbDecimales]="2"
                                [libelle]="item.libelleDomaine"
                                suffix="%">
                        </custom-input>
                    </ng-container>
                </div>

                <!--Aucun domaine de prestation-->
                <div class="row" *ngIf="model.listePourcentages.length === 0">
                    <div class="col-md-12 liste_vide" [translate]="'admin.frais.indemnites.parametres.pourcentages.aucunDomainePrestation'"></div>
                </div>
            </mat-card-content>
        </ng-container>
    </mat-card>

    <!--Bouton flottant de sauvegarde-->
    <floating-button [listeActions]="listeActions" [isPending]="isSaving"></floating-button>
</form>

<!--Affiché pendant le chargement des délais forfaitaires-->
<ng-template #loadingReglesConf>
    <please-wait class="content"></please-wait>
</ng-template>

<!--Affiché pendant le chargement des pourcentages-->
<ng-template #loadingPourcentages>
    <please-wait class="content"></please-wait>
</ng-template>
